var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('notifications',{attrs:{"group":"ta-alfred","position":"bottom right","classes":"n-light","speed":500}}),_c('notifications',{attrs:{"group":"ta-info","duration":5000,"width":500,"animation-name":"v-fade-left","position":"top left"}}),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }